export const DEFAULT_EMPTY_TOTAL_RESULTS = 0

export const MOST_SEARCHED_MAKES_KEY = 'mostSearchedMakes'
export const REST_OF_MAKES_KEY = 'restOfMakes'

export const INPUT_SEARCH_FILTER_VEHICLE_ID = 'input-search-filter-vehicle-id'

export const SKELETON = {
  COUNT: 5,
  HEIGHT: 50
}

export const BASE_ELEMENTS_TYPES = {
  LABEL: 'label'
}

export const BASE_CLASS = 'mt-FormVehicles'
export const WRAPPER_CLASS_NAME = `${BASE_CLASS}-wrapper`

export const DESIGNS = {
  BASIC: 'basic',
  CENTER_TO_CUSTOM_RELATIVE_POPOVER: 'centerToCustomRelativePopover',
  MODAL: 'modal',
  RIGHT_POPOVER: 'rightPopover'
}

export const MODES = {
  ADD: 'add',
  EXCLUDE: 'exclude'
}

export const INPUT_SEARCH_DEBOUNCE = 500

export const NO_OP = () => {}

export const ARIA_LIVE = {
  POLITE: 'polite',
  ASSERTIVE: 'assertive'
}

export const ARIA_ATOMIC = {
  TRUE: 'true',
  FALSE: 'false'
}

export const BASE_ELEMENTS = {
  DIV: 'div',
  FIELDSET: 'fieldset',
  LEGEND: 'legend',
  LABEL: 'label'
}
